var map = {
	"./Image01.jpg": "39d9",
	"./Image02.jpg": "18de",
	"./Image03.jpg": "f236",
	"./Image04.jpg": "82f0",
	"./Image05.jpg": "01ec",
	"./Image06.jpg": "8af6",
	"./IphoneX.png": "2da3",
	"./concept.png": "02e8",
	"./cph_nyhavn.jpg": "5e57",
	"./dummy_placeholder.png": "7c90",
	"./img-large.png": "fe79",
	"./img-round.png": "a3f9",
	"./img-top.png": "b487",
	"./logo.png": "cf05",
	"./mobile-phone-black.png": "fb25",
	"./mobile-phone-green.png": "c5f4",
	"./monitor-black.png": "830b",
	"./monitor-green.png": "a45c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";